/******************
	* This is a basic helper function that allows you to extend one object into another
	* Useful for overwriting default options
	* Usage Examples:
		var defaults = {num: 1, str: 'hi', bool: false}
		var selections = {str: 'goodbye'}
		var merged = blue.util.extend({}, defaults, selections)

		//merged -> {num: 1, str: 'goodbye', bool: false}

******************/
import { util } from '~/core';
import { merge } from 'lodash-es';
export default merge;
util.extend = merge;